export const DASH_MARKETING_PAGE = "https://dash.dropbox.com";
export const DASH_WEBAPP = "https://www.dash.ai";
export const DASH_WEBAPP_STAGE = "https://staging.dash.ai";
export const DASH_WEBAPP_HOSTNAME = "www.dash.ai";
export const DASH_WEBAPP_AMPLIFY_HOSTNAME = "d2unov8w0g44qf.amplifyapp.com";
export const DASH_WEBAPP_MASTER_HOSTNAME = "d7kgc1ikry9m3.amplifyapp.com";
export const DASH_WEBAPP_DOMAIN = "dash.ai";
export const DROPBOX_LOGOUT_URL = "https://www.dropbox.com/logout";
export const DROPBOX_ONBOARDING_START_URL =
  "https://www.dropbox.com/dash/get-started";
export const DROPBOX_DELETE_ACCOUNT_INSTRUCTIONS =
  "https://help.dropbox.com/account-access/delete-account";
export const DROPBOX_SETTINGS_PAGE_FOR_DASH_URL =
  "https://www.dropbox.com/account?dash";
export const DROPBOX_TEAM_JOIN_URL = "https://www.dropbox.com/team/";
export const DROPBOX_ADMIN_CONSOLE_URL = "https://www.dropbox.com/team/admin";

// You may want to use getConnectorsUrl() instead of CONNECTORS_URL.
// eslint-disable-next-line no-restricted-syntax
export const CONNECTORS_URL = "https://www.dropbox.com/dash/connectors";
export const BROWSER_EXTENSION_URL = "https://dash.dropbox.com/extension";
export const DASH_CONNECTORS_URL = `${DASH_WEBAPP}/settings/apps`;

export const DESKTOP_DOWNLOAD_URL = "https://dropbox.com/dash/download";
export const HELP_CENTER =
  "https://dash.dropbox.com/landing?destination=help-center";

export const PRIVACY_AND_LEGAL =
  "https://dash.dropbox.com/landing?destination=privacy";
export const DASH_SECURITY = "https://dash.dropbox.com/security";

export const AI_LEARN_MORE_URL = "https://www.dropbox.com/ai-principles";
export const CHROME_EXTENSION_WEB_STORE =
  "https://chromewebstore.google.com/detail/dropbox-dash-beta/aclbkdnphcdelflmgjgmgbahlfngidma";
export const FIREFOX_EXTENSION_WEB_STORE =
  "https://client.dropbox.com/firefox/dash-scout/download/{c98b690b-0b48-4477-9630-081fd7de369d}";
export const EDGE_EXTENSION_WEB_STORE =
  "https://microsoftedge.microsoft.com/addons/detail/dropbox-dash-beta/kblhiphkmkbpcnokbgcnlgcnahnddedl";
export const SAFARI_EXTENSION_WEB_STORE =
  "https://apps.apple.com/us/app/dropbox-dash-for-business/id6446790295";

export const MOBILE_APP_DEEP_LINK_URL = "dash://?source=web-banner";
export const IPHONE_MOBILE_APP_STORE_URL =
  "https://apps.apple.com/us/app/dropbox-dash/id6450553960";
export const ANDROID_MOBILE_APP_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.dropbox.dash";
export const INTERNAL_ANDROID_MOBILE_APP_STORE_URL =
  "https://play.google.com/apps/testing/com.dropbox.dash";

const DASH_EXTENSION_AUTH_URL =
  "https://www.dropbox.com/save_to_dropbox/web_auth_redirect";

export const DASH_SALES_CONTACT = "https://dash.dropbox.com/contact-sales";

export const DEV_ONBOARDING_DESKTOP_URL =
  "dropbox-dash-canary-dev://?from=onboardingFinished";
export const ONBOARDING_DESKTOP_URL = "dropbox-dash://?from=onboardingFinished";

export const POST_EXTENSION_INSTALL_URL = `${DASH_WEBAPP}/post-extension-install`;

export const isRedirectAllowedWithUrl = (urlOrPath: string): boolean => {
  if (
    urlOrPath.startsWith("/") ||
    urlOrPath.startsWith(DASH_EXTENSION_AUTH_URL)
  ) {
    return true;
  }
  try {
    // creates a new URL object with the current location as the base
    // if urlOrPath is a full URL, base will be ignored
    // otherwise, urlOrPath is used as a path relative to the current location
    const url = new URL(urlOrPath, location.origin);
    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return false;
    }
    return url.host === location.host;
  } catch {
    return false;
  }
};
